import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import "./digital.css";
import HeroSection from "./HeroSection";
const BenefitSection = lazy(() => import("./BenefitSection"));
const InnovationSection = lazy(() => import("./InnovationSection"));
const AdvantageSection = lazy(() => import("./AdvantageSection"));

const DigitalTransformation = () => {
  return (
    <div>
      <Helmet>
        <title>
          LENTERA enterprise applications, business process optimization,
          enterprise software development.
        </title>
        <meta
          name="description"
          content="Automate processes, enhance operational efficiency, and reduce errors across industries like manufacturing, healthcare, finance, education, transportation, and retail."
        />
        <meta
          name="keywords"
          content="LENTERA digital innovation, workflow digitization, industry-specific digital transformation, digital tools for business, reduce manual processes, improve business performance, technology-driven growth"
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <BenefitSection />
        <InnovationSection />
        <AdvantageSection />
      </Suspense>
    </div>
  );
};

export default DigitalTransformation;
